import axios from 'axios';
import {CLIENT_API_RESPONSE_TIMEOUT} from 'app/services/api';

const baseURL = process.env.MY_MATCHES_URL;

const myMatchesApi = axios.create({baseURL, timeout: CLIENT_API_RESPONSE_TIMEOUT});

myMatchesApi.interceptors.request.use(
  async config => {
    const {tokenValidationForXHR} = await import('app/services/firebase');
    const token = await tokenValidationForXHR();
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

/**
 * Get pushed matches or matches from followed entities,
 * Authorization-Header with Bearer token is necessary for this call
 *
 * @param {string} dir next | prev (next contains pointer-day)
 * @param {string} minMatches minimal number of matches that should be fetched, default: 30, will auto-fill to complete matchday
 * @returns Promise from the http-request
 */
const getMyMatches = (dir = 'next', minMatches = '30') => myMatchesApi.get(`/matches?dir=${dir}&min=${minMatches}`);

const fetchNextCall = request => {
  if (request) {
    const [requestUrl, queryString] = request.split('?');
    const urlSearchParams = new URLSearchParams(queryString);
    const params = Object.fromEntries(urlSearchParams.entries());
    return myMatchesApi.get(requestUrl, {params});
  }
};

export {getMyMatches, fetchNextCall};
